import styled from 'styled-components';
import colors from '../../assets/styles/colors';

export const ModalInfoContainer = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  background: ${colors.bgOverlay};
  z-index: 99;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: .2s;
  opacity: ${prop => prop.open ? '1' : '0'};
  height: ${prop => prop.open ? 'auto' : '0'};
  overflow: ${prop => prop.open ? '' : 'hidden'};
`;

export const ModalInfoContent = styled.div`
  width: 100%;
  max-width: 650px;
  background: ${colors.white};
  box-shadow: 0px 5px 10px ${colors.shadow};
  -webkit-box-shadow: 0px 5px 10px ${colors.shadowHover};
  -moz-box-shadow: 0px 5px 10px ${colors.shadowHover};
  border-radius: 16px;
  padding: 20px;
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

export const ModalInfoHead = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-bottom: 50px;

  svg {
    cursor: pointer;
  }
`;

export const ModalInfoBody = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  margin-bottom: 60px;
`;

export const ModalInfoFooter = styled.div`
  display: flex;
  flex-direction: column;
  margin: 30px 0;
`;

export const ModalInfoBodyIcon = styled.div`
  width: 67px;
  height: 67px;
  background: ${prop => prop.backgroundIcon};
  box-shadow: 0px 5px 10px ${colors.shadow};
  -webkit-box-shadow: 0px 5px 10px ${colors.shadow};
  -moz-box-shadow: 0px 5px 10px ${colors.shadow};
  border-radius: 25px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ModalInfoBodyLabel = styled.p`
  margin-top: 30px;
  font-weight: 600;
  font-size: 20px;
  line-height: 24px;
  letter-spacing: 0.03em;
  color: ${colors.black};
  text-align: center;
`;

export const ModalInfoBodyDescription = styled.p`
margin-top: 20px;
  max-width: 521px;
  font-size: 16px;
  line-height: 23px;
  color: ${colors.textPrimary};
  letter-spacing: 0.03em;
  text-align: center;
`;

export const ModalInfoFooterButton = styled.button`
  width: 100%;
  max-width: 292px;
  margin: auto;
  height: 32px;
  letter-spacing: 0.03em;
  font-weight: bold;
  font-size: 14px;
  line-height: 17px;
  border-radius: 48px;
  transition: .2s;

  &:first-child {
    background: ${colors.bgPrimary};
    color: ${colors.white};
    box-shadow: 0px 5px 10px ${colors.shadow};
    -webkit-box-shadow: 0px 5px 10px ${colors.shadow};
    -moz-box-shadow: 0px 5px 10px ${colors.shadow};
    border: 1px solid ${colors.bgPrimaryLight};

    &:hover {
      background: ${colors.bgPrimaryHover};
      border: 1px solid ${colors.bgPrimaryLight};
      box-shadow: 0px 5px 15px ${colors.shadowHover};
      -webkit-box-shadow: 0px 5px 15px ${colors.shadowHover};
      -moz-box-shadow: 0px 5px 15px ${colors.shadowHover};
    }
  }

  &:last-child {
    margin-top: 20px;
    background: ${colors.white};
    border: 1px solid ${colors.textSecondary};
    box-shadow: 0px 5px 10px ${colors.shadow};
    -webkit-box-shadow: 0px 5px 10px ${colors.shadow};
    -moz-box-shadow: 0px 5px 10px ${colors.shadow};
    color: ${colors.textPrimary};

    &:hover {
      box-shadow: 0px 5px 15px ${colors.shadowHover};
      -webkit-box-shadow: 0px 5px 15px ${colors.shadowHover};
      -moz-box-shadow: 0px 5px 15px ${colors.shadowHover};
    }
  }
`;
